import React from "react"

function Information({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13 9.33782C14.4709 8.48697 16.1786 8 18 8C23.5228 8 28 12.4771 28 18C28 23.5228 23.5228 28 18 28C12.4771 28 7.99998 23.5228 7.99998 18C7.99998 16.1786 8.48695 14.4709 9.3378 13"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
      />
      <path
        d="M18 23V17"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
      />
      <path
        d="M18 13C18.5523 13 19 13.4477 19 14C19 14.5523 18.5523 15 18 15C17.4477 15 17 14.5523 17 14C17 13.4477 17.4477 13 18 13Z"
        fill="#003E4C"
      />
    </svg>
  )
}
export default Information
